import { useContext } from "react";
import { BudgetDetailContext } from "../contexts/BudgetDetailContext";

export const useBudgetDetails = () => {
    return useContext(BudgetDetailContext);
}